export default __webpack_public_path__ + "static/baner-EasyBoard-2-6f33e2249271d1cc45031a67a4228e4e.jpg";